import { create } from 'zustand'
import { CLAVE_SESION_2FA, crearSolicitudDosPasos } from '@/lib/dosPasos'

/**
 * Sesión 2FA del asesor (`X-Sesion-2FA`, ver `lib/dosPasos.js`). La emite la API al activar o
 * verificar el código y dura 12 h.
 *
 * Vive en memoria y en sessionStorage, NUNCA en localStorage (mismo criterio que el AdminPanel):
 * una prueba de doble factor no debe sobrevivir al navegador cerrado.
 */

function leerGuardada() {
  try {
    return window.sessionStorage.getItem(CLAVE_SESION_2FA)
  } catch {
    return null
  }
}

/** La única petición de 2FA en vuelo: la abre el interceptor y la cierra el diálogo. */
export const solicitudDosPasos = crearSolicitudDosPasos()

export const useDosPasosStore = create((set) => ({
  sesion2fa: leerGuardada(),
  // Hay peticiones esperando la 2FA ('activar' | 'verificar'): el diálogo se abre con esto.
  motivo: null,
  guardarSesion: (token) => {
    try {
      window.sessionStorage.setItem(CLAVE_SESION_2FA, token)
    } catch {
      // sessionStorage bloqueado: queda solo en memoria
    }
    set({ sesion2fa: token })
  },
  borrarSesion: () => {
    try {
      window.sessionStorage.removeItem(CLAVE_SESION_2FA)
    } catch {
      // nada que borrar
    }
    set({ sesion2fa: null })
  },
}))

solicitudDosPasos.suscribir((motivo) => useDosPasosStore.setState({ motivo }))
